
import $ from 'jquery';
import Vue from 'vue';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { Component } from 'vue-property-decorator';
import { GpsTrackerUiClient, GpsTrackerDto } from '../../backend/backendapi';
import GpsTrackerEditModal from './editModal/GpsTrackerEditModal';
import GpsTrackerStore from '../../../stores/GpsTrackerStore';
import { WindowType } from '../../../util';
import { paginationOptions, searchOptions } from '../../../util/vue-good-table';
import { handleError, initClient } from '../../../api';

declare var window: WindowType;

@Component({
  name: 'GpsTrackerListModal',
  components: {
    GpsTrackerEditModal,
    VueGoodTable,
  },
})
export default class GpsTrackerListModal extends Vue {
  private readonly api = initClient(GpsTrackerUiClient);
  readonly store = new GpsTrackerStore();

  get canEdit(): boolean {
    return window.application.permissions.map.gps.edit;
  }

  get columnsConfig(): any[] {
    return [
      {
        label: this.$i18n.t('map.gps.tracker.model.imei').toString(),
        field: (e: GpsTrackerDto) => e.imei,
      },
    ].concat(this.canEdit ? [{
      label: this.$i18n.t('map.gps.tracker.modal.list.actions').toString(),
      field: 'actions',
      width: '7em',
    }] as any[] : []);
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  async mounted(): Promise<void> {
    await this.store.loadIfAbsent();
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  addGpsTracker(): void {
    (this.$refs.editModal! as GpsTrackerEditModal).open(GpsTrackerDto.fromJS({
      id: 0,
      fkAccountId: 0,
      fkCellId: undefined,
      imei: '',
      phoneNumber: '',
      type: 'RMT700',
      apn: '',
      apnUser: '',
      apnPwd: '',
      mode: 'AUTO',
      networkMode: '',
      band: '',
      modeReportIntervalSec: 0,
      triggerDistanceTraveledDutyId: undefined,
      triggerDistanceTraveledDutyMeters: 0,
      triggerDistanceTraveledDutySetPointSeconds: 0,
    }));
  }

  editGpsTracker(tracker: GpsTrackerDto): void {
    (this.$refs.editModal! as GpsTrackerEditModal).open(tracker);
  }

  async deleteConfirm(tracker: GpsTrackerDto): Promise<void> {
    if (!confirm(this.$t('map.gps.tracker.modal.list.confirmDelete').toString())) {
      return;
    }

    try {
      await this.api.delete(tracker.id);
      this.store.forgetGpsTracker(tracker);

      this.$toasted.info(this.$t('txtDeleted').toString());
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    }
  }
}
